<template lang="pug">
#ShareLink.w5.absolute.center.right-2.top-1-l.pa3.bg-white.shadow-1.br2(v-if="open")
    b.bg-white.mt0 Share map
    p Copy the URL to share this map view.
    input#shareInput(type="text" size="50" :value="url")
    .clipboard.dib.pointer(@click="copyToClipboard")
    p.f7(v-if="copied") URL copied to clipboard.
</template>

<script>
export default {
    name: 'ShareLink',
    props: ['open'],
    data: () => ({ copied: false }),
    created() {
        window.ShareLink = this;
    },
    computed: {
        url() {
            return window.location;
        },
    },
    methods: {
        copyToClipboard() {
            const input = document.querySelector('#shareInput');
            input.focus();
            input.select();
            document.execCommand('copy');
            this.copied = true;
        },
    },
    watch: {
        open() {
            this.copied = false;
        },
    },
};
</script>

<style scoped>
#ShareLink {
    pointer-events: all;
    right: 5em;
    width: 20em;
}

input {
    font-size: 12px;
    width: 22em;
}

.clipboard {
    background-image: url(../assets/noun_clipboard_75973.svg) !important;
    background-size: cover;
    width: 1.5em;
    height: 1.5em;
    vertical-align: bottom;
}

@media screen and (min-width: 60em) {
    .top-1-l {
        top: 10px; /* to align with mapbox controls */
    }
}
</style>
